import { Component, EventEmitter, Input, OnInit, Output ,ViewChild} from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AppService } from 'src/modules/base/shared/services/app.service';
import { TncComponent } from 'src/modules/base/components/tnc/tnc.component';
import { ModalSize, SmartModalService } from 'src/modules/base/services/smart-modal.service';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { CommonService } from 'src/modules/base/services/common.service';
import { ADService } from 'src/app/ad.service';
declare var turf: any

@Component({
    selector: 'app-patient-registration',
    templateUrl: './patient-registration.component.html',
    styleUrls: ['./patient-registration.component.scss'],
    standalone: false
})
export class PatientRegistrationComponent implements OnInit {
  registrationForm: FormGroup;
  @ViewChild("facilitySelector") facilitySelector: any; 
  headerInfo: any = {}; question: any = { "key": "dob" }
  verify: boolean = false; maxDateNumber: any = 0;
  registerRes: any;
  isKarexpert: string = ''; countryCode: any[] = [];
  @Output() emitBackEvent = new EventEmitter<any>();
  submitted: boolean = false;
  fromPage: any = 1;
  latLong: any = {};

  @Input() config: any = {};
  otpCompConfig: any = {};
  facilitySearchSelect:any
  titleSearchSelect:any
  countryCodeSearchSelect:any

  constructor(
    private formBuilder: FormBuilder,
    private appService: AppService,
    private modalService: SmartModalService,
    private baseService: BaseService,
    private alertService: AlertsService,
    private spinner: LoaderService,
    private commonService: CommonService,
    private adService: ADService,
  ) { }

  ngOnInit() {
    this.headerInfo = this.appService.getAppHeader();
    this.maxDateNumber = 0;
    if (window.location.hostname.substring(0, window.location.hostname.indexOf('.')) != 'karexpert' && window.location.hostname != 'localhost') {
      this.registrationForm = this.formBuilder.group({
        facility_id: [''],
        "name_.prefix":[''],
        name_: ['', Validators.required],
        telecom: ['', Validators.required],
        account_url: [''],
        termscondition: [true, Validators.required]
      });
    } else {
      this.isKarexpert = 'karexpert';
      this.registrationForm = this.formBuilder.group({
        facility_id: [''],
        "name_.prefix":[''],
        name_: ['', Validators.required],
        telecom: ['', Validators.required],
        account_url: ['', Validators.required],
        termscondition: [true, Validators.required]
      });
    }
    if (this.headerInfo.enable_telecom_code) {
      this.registrationForm.addControl("telecom_code", this.formBuilder.control('', Validators.required))
    }
    this.commonService.initGeolocation(callback => {
      if (callback.latitude && callback.longitude) {
        this.latLong = callback;
        // if (this.headerInfo.enable_telecom_code) {
          // this.baseService.getCountry(this.latLong.latitude, this.latLong.longitude, this.headerInfo.account_id).then((res: any) => {
          //   if (res && res.country) {
          //     // if (this.headerInfo.full_registration_login) {
          //     // this.registrationForm.controls['country'].setValue(res.country);
          //     // }
          //   }
          // });
        // }
      }
    });
    if (this.headerInfo.enable_telecom_code) {
      // this.getGender();
      // this.getCountry();
      this.getCountryCode();
    }

    if (this.adService.isADLogin()) {
      if (this.config.fullName) {
        this.registrationForm.controls.name_.setValue(this.config.fullName);
      }
      this.otpCompConfig = this.config;
    }
    if (this.headerInfo?.org_selection_at_self_reg) {
      this.getFacilitySelection()
    }
    this.getPatientTitle()
  }

  get f() { return this.registrationForm.controls; } //return this.loginForm.controls;

  selfRegistration() {

  }

  registerPatient() {
    this.spinner.showSpinner();
    this.submitted = true;
    if (this.registrationForm.invalid) {
      this.spinner.hideSpinner();
      return;
    }

    if (this.headerInfo?.org_selection_at_self_reg && !this.registrationForm.get('facility_id')?.value) {
      this.alertService.error('Facility Name is required');
      this.spinner.hideSpinner();
      return;
    }

    var letters = /^[A-Za-z ]+$/;
    if (!this.registrationForm.controls['name_'].value.match(letters)) {
      this.registrationForm.controls.name_.setErrors({ 'incorrect': true })
      this.spinner.hideSpinner();
      return
    }

    let data = {
      "name_": {
        "prefix": this.registrationForm.controls['name_.prefix'].value,
        "text": this.registrationForm.controls['name_'].value,
        "given": "",
        "family": ""
      },
      "facility_id": this.registrationForm.controls['facility_id'].value,
      "telecom": this.registrationForm.controls['telecom'].value,
      "account_url": this.registrationForm.controls['account_url'].value == "" ? window.location.hostname : this.registrationForm.controls['account_url'].value
    }
    if (this.latLong.latitude && this.latLong.longitude) {
      data['latitude'] = this.latLong.latitude;
      data['longitude'] = this.latLong.longitude;
    }
    if (this.headerInfo.enable_telecom_code) {
      data['telecom_code'] = this.registrationForm.controls['telecom_code'].value;
    }
    this.baseService.add(data, 'self_registration', true, 'patient-registration').subscribe(
      (res) => {
        this.spinner.hideSpinner();
        this.submitted = false
        if (res.errCode == 0) {
          this.registerRes = res.resource[0]
          if (this.registerRes.otp_verified == true && this.registerRes.page_no == 3) {
            this.alertService.info("You are already registered !!")
            this.backToLogin();
          } else {
            this.verify = true;
          }
        } else {
          this.alertService.error(res.message)
        }
      }
    )

  }


  // genderSelection(event:any){
  //   this.selctedGender = event.target.value
  // }

  // getGender(){
  //   this.spinner.showSpinner();
  //   this.baseService.get("GET_GENDER","","valueset_login","system-management").subscribe((response:any)=>{
  //     this.spinner.hideSpinner();
  //     if(response.errCode == 0){
  //       this.genderList = response.resource;
  //     }else{
  //       this.alertService.error(response.message)
  //     }
  //   })
  // }

  


  showTnc() {
    this.modalService.open(TncComponent, '', 'Terms of Service and Data Privacy Notice', ModalSize.Lg, 'center', true).subscribe(res => {
      if (res) {
        console.log('tnc modal closed');
      }
    }, err => {
      console.error('error occured in tnc modal', err);
    })
  }

  backToLogin() {
    let val = {
      "back": true
    }
    this.emitBackEvent.emit(val)
  }

  valueChange(event: any) {
    console.log("event is :: ", event);
  }

  backToRegistration(event) {
    if (event.back == true)
      this.verify = false
    else if (event.set_password == true)
      this.emitBackEvent.emit(event);
    else if (event.login != undefined && event.login) {
      this.backToLogin();
    }
    if(this.registrationForm.controls && this.registrationForm.controls.facility_id.value !=""){
        this.facilitySearchSelect.controls.facility_id.value = this.registrationForm.controls.facility_id.value
    }
  }

  onDropdownOptionsLoaded(event?) {
    if (event.options != undefined && event.options.length == 1 && this.facilitySelector.dataFromApiModel == '') {
      this.facilitySelector.writeValue(event.options[0].id)
    }
  }

  onSelectFacility(event?) {
    this.registrationForm.controls.facility_id.setValue(event.id)
  }

  onSelectTelecomCode(event?) {
    this.registrationForm.controls.telecom_code.setValue(event?.telecom_code ?? event?.id ?? '')
  }

  getFacilitySelection() {
    this.facilitySearchSelect = {
      datasource: {
        "application": "account-management",
        "resource": "get_facility_details",
        "query_id": "GET_FACILITY_LIST",
        "search": '',
        "args": `account_id:` + this.headerInfo.account_id,
        "filter": "status:active",
        "search_columns": "name,id,primary_address.cityDisplayName"
      },
      format: "fn=function(item){ return item.name + (item.primary_address?.cityDisplayName ? ' | ' + item.primary_address.cityDisplayName : '') }",
      controls: {
        facility_id: {
          value: ""
        }
      },
      question: {
        format: "fn=function(item){ return item.name + (item.primary_address?.cityDisplayName ? ' | ' + item.primary_address.cityDisplayName : '') }",
        defaultsetting: {
          "singleSelection": true,
          "checkBoxRequired": false,
          "closeDropDownOnSelection": true,
          "apliCall": true
        },
        getterKey: 'id',
        getterValue: 'name',
        required: true,
        req_keys: [
        "id",
        "name",
        "primary_address",
        "status"
      ],
        key: "facility_id"
      },
      defaultsetting: {
        "singleSelection": true,
        "checkBoxRequired": false,
        "closeDropDownOnSelection": true,
        "apliCall": true,
        "advancesearch":false
      }
    }
  }


  getPatientTitle(){
    this.titleSearchSelect = {
      "datasource": {
        "resource": "patient_titles",
        "application": "facility-management",
        "args": "resourceId:title,system:karexpert",
        "query_id": "GET_PATIENT_TITLES"
      },
      controls: {
        "name_.prefix": {
          value: ""
        }
      },
      question: {
        defaultsetting: {
          "singleSelection": true,
          "checkBoxRequired": false,
          "closeDropDownOnSelection": true,
          "apliCall": false
        },
        getterKey: 'code',
        getterValue: 'display',
        required: true,
        req_keys: [
          "code",
          "display"
        ],
        key: "name_.prefix"
      },
      defaultsetting: {
        "singleSelection": true,
        "checkBoxRequired": false,
        "closeDropDownOnSelection": true,
        "apliCall": false,
        "advancesearch": false
      }
    }
  }

  onSelectTitle(event?) {
    if (event) {
      this.registrationForm.controls['name_.prefix'].setValue(event.id)
    }
  }

  getCountryCode() {
    this.countryCodeSearchSelect = {
      datasource: {
        "application": "account-management",
        "resource": "country_telecom_code_login",
        "query_id": "GET_COUNTRY_CODE_LOGIN",
        "search": '',
        "args": `account_id:` + this.headerInfo.account_id,
        "filter": "status:active",
        "search_columns": "name,id,primary_address.cityDisplayName"
      },
      controls: {
        telecom_code: {
          value: ""
        }
      },
      question: {
        defaultsetting: {
          "singleSelection": true,
          "checkBoxRequired": false,
          "closeDropDownOnSelection": true,
          "apliCall": true
        },
        format: "fn=function(item) { return item.telecom_code + ' | ' + item.countryDisplayName }",
        getterKey: 'telecom_code',
        getterValue: 'short_name',
        required: true,
        req_keys: [
          "short_name",
          "telecom_code",
          "status",
          "countryDisplayName"
        ],
        key: "telecom_code"
      },
      defaultsetting: {
        "singleSelection": true,
        "checkBoxRequired": false,
        "closeDropDownOnSelection": true,
        "apliCall": true
      }
    }
  }

}


